'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconLayerGroup, iconLayerGroupTag } from '@ni/nimble-components/dist/esm/icons/layer-group';
import { wrap } from '../../utilities/react-wrapper';

export type { IconLayerGroup };
export { iconLayerGroupTag };
export const NimbleIconLayerGroup = wrap(IconLayerGroup);